import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs/internal/observable/combineLatest';
import { ConstantService } from 'src/app/core/services/constant.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { SaleOrderTemplateService } from 'src/app/core/services/so-template.service';
import { DateFormats } from 'src/app/shared/enums/date-formats.enum';
import { TemplateNewFieldPopupComponent } from './template-new-field-popup/template-new-field-popup.component';

@Component({
    selector: 'eci-so-template-details',
    templateUrl: './so-template-details.component.html',
    styleUrls: ['./so-template-details.component.scss'],
})
export class SaleOrderTemplateDetailsComponent implements OnInit {

    header: string = 'Sale Order Template Details';
    showLoader: boolean = false;

    requiredFields: string[] = [];
    values4Choose: string[] = [];

    template: any;
    marketplaceId: number;

    isCreateMode: boolean = false;
    templateDetails: any;

    amountRequiredFields: number = 0;

    dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    displayedColumns = [
        'soFieldName',
        'marketplaceFieldName',
        'delete'
    ];

    availableDateFormats = [];

    get valuesForChoose(): string[] {
        return this.values4Choose.filter(el => !this.dataSource.data.some(val => val.fieldName === el));
    }

    get prepareTemplate2Save(): any {
        this.dataSource.data = this.dataSource.data.filter(el => !!el.fieldName);
        this.dataSource.data?.forEach(el => {
            el?.marketplaceFieldName?.toString()?.trimEnd();
            el?.fieldName?.toString()?.trimEnd();
        });
        return {
            marketplaceId: !!this.marketplaceId ? Number(this.marketplaceId) : undefined,
            template: JSON.stringify(this.dataSource.data),
        }
    }

    constructor(
        private constSvc: ConstantService,
        private route: ActivatedRoute,
        private soTemplateSvc: SaleOrderTemplateService,
        private notify: NotificationService,
        private router: Router,
        private dialog: MatDialog,
    ) {
    }

    ngOnInit() {
        let keys = Object.keys(DateFormats);
        this.availableDateFormats = keys.slice(keys.length / 2);

        this.route.params.subscribe(value => {
            if (value.id) {
                combineLatest([
                    this.constSvc.getSettingsDetails('SO_FIELDS_NAME'),
                    this.soTemplateSvc.getOne(value.id)
                ]).subscribe(([res, result]) => {
                    this.prepareValues(res);

                    this.marketplaceId = result.marketplaceId;
                    this.dataSource = new MatTableDataSource(this.parseTemplateData(result.template));
                    this.templateDetails = result;
                    this.amountRequiredFields = this.dataSource.data.length;
                })
            } else {
                this.marketplaceId = Number(value.marketplaceId);
                this.constSvc.getSettingsDetails('SO_FIELDS_NAME').subscribe(res => {
                    this.isCreateMode = true;

                    this.prepareValues(res);
                    this.dataSource.data = this.prepareDataSource(this.requiredFields);
                    this.amountRequiredFields = this.dataSource.data.length;
                });
            }
        });
    }

    private parseTemplateData(template: unknown): any[] {
        if (Array.isArray(template)) {
            return template;
        }
        if (typeof template === 'string') {
            const parsed = JSON.parse(template);
            return Array.isArray(parsed) ? parsed : [];
        }
        return [];
    }

    
    private prepareValues(res): void {
        let dataArr = res?.value?.split(' , ');
        dataArr.forEach((element) => {
            let parseVal = JSON.parse(element);

            if (parseVal.isRequired) {
                this.requiredFields.push(parseVal.name);
            } else {
                this.values4Choose.push(parseVal.name);
            }
        });
    }

    save(): void {
        // if (this.dataSource.data.find(el => !el.marketplaceFieldName && el.isRequired)) {
        //     this.notify.showError('Not all required fields have match')
        //     return;
        // }
        //const unmatchedFields = this.dataSource.data.filter(el => !el.marketplaceFieldName && el.isRequired);
        const unmatchedFields = this.dataSource.data.filter(
            (el) => (el.marketplaceFieldName === undefined || el.marketplaceFieldName === null || el.marketplaceFieldName === '') && el.isRequired
          );
        console.log('Data Source Before Update:', this.dataSource.data);
        console.log('Unmatched Fields:', unmatchedFields);
            
        if (unmatchedFields.length > 0) {
            console.log('Unmatched Required Fields:', unmatchedFields);
            this.notify.showError('Not all required fields have a match');
            return;
        }      

        if (unmatchedFields.length > 0) {
            console.log('Unmatched Required Fields:', unmatchedFields);
            this.notify.showError('Not all required fields have match');
            return;
        }        
        this.soTemplateSvc.saveTemplate(this.prepareTemplate2Save).subscribe(result => {
            this.notify.showSuccessMessage('Saved successfully');
            this.router.navigate(['../'], { relativeTo: this.route });
        });
    }

    update(): void {
        // if (this.dataSource.data.find(el => !el.marketplaceFieldName && el.isRequired)) {
        //     this.notify.showError('Not all required fields have match')
        //     return;
        // }
        //const unmatchedFields = this.dataSource.data.filter(el => !el.marketplaceFieldName && el.isRequired);

        const unmatchedFields = this.dataSource.data.filter(
            (el) => (el.marketplaceFieldName === undefined || el.marketplaceFieldName === null || el.marketplaceFieldName === '') && el.isRequired
          );

        console.log('Data Source Before Update:', this.dataSource.data);
        console.log('Unmatched Fields:', unmatchedFields);
            
        if (unmatchedFields.length > 0) {
            console.log('Unmatched Required Fields:', unmatchedFields);
            this.notify.showError('Not all required fields have a match');
            return;
        }  

        if (!this.templateDetails.id) {
            return;
        }
        this.soTemplateSvc.updateTemplate(this.templateDetails.id, this.prepareTemplate2Save).subscribe(result => {
            this.notify.showSuccessMessage('Updated successfully');
            this.router.navigate(['../../'], { relativeTo: this.route });
        });
    }

    prepareDataSource(arr: string[]): any[] {
        arr.push('Date format');
        let finishArr = arr.map(field => {
            return {
                fieldName: field,
                marketplaceFieldName: '',
                isRequired: true,
            };
        });

        return finishArr;
    }

    back(): void {
        window.history.back();
    }

    addRow(): void {
        let dialogRef = this.dialog.open(TemplateNewFieldPopupComponent);
        dialogRef.componentInstance.isRequired = false;
        dialogRef.componentInstance.fields4Select = this.valuesForChoose;

        dialogRef.afterClosed().subscribe(value => {
            if (!value) return undefined;

            this.dataSource.data = [...this.dataSource.data, {
                fieldName: value.soFieldName,
                marketplaceFieldName: value.marketplaceFieldName,
            }];
        });
    }

    delete(index: number): void {
        this.dataSource.data.splice(index, 1);
        this.dataSource.data = [...this.dataSource.data];
    }

    edit(element: any): void {
        let dialogRef = this.dialog.open(TemplateNewFieldPopupComponent);
        dialogRef.componentInstance.isRequired = element.isRequired;
        dialogRef.componentInstance.fields4Select = [element.fieldName];

        dialogRef.componentInstance.soFieldName = element.fieldName;
        dialogRef.componentInstance.marketplaceFieldName = element.marketplaceFieldName;
        dialogRef.componentInstance.isDateField = element.fieldName === 'Date format';
        dialogRef.componentInstance.dateFormats = this.availableDateFormats;

        dialogRef.afterClosed().subscribe(value => {
            if (!value) return;
            element.fieldName = value.soFieldName;
            element.marketplaceFieldName = value.marketplaceFieldName;
        });
    }
}
